import { useAnalytics } from "contexts/AnalyticsContext";
import { useProduct } from "contexts/ProductContext";
import { DatabaseBisacCodes } from "./DatabaseBisacCodes";
import { FinalBisacCodes } from "./FinalBisacCodes";
import { useBisacSubjects } from "./useBisacSubjects";

export const BisacTab = () => {
  const { product } = useProduct();
  const { gaEvent } = useAnalytics();
  const {
    databaseSubjects,
    finalSubjects,
    isFinal,
    addCodes,
    addSubject,
    removeSubject,
    reorder,
  } = useBisacSubjects();

  if (!product) return null;

  return (
    <div className="flex items-start gap-4 h-full">
      <DatabaseBisacCodes
        subjects={databaseSubjects}
        isFinal={isFinal}
        onAdd={addSubject}
        onRemove={removeSubject}
      />
      <FinalBisacCodes
        subjects={finalSubjects}
        onOpenModal={() =>
          gaEvent({
            type: "open_bisac_search_modal",
            payload: { book: product.id },
          })
        }
        onCopy={(codesCount) =>
          gaEvent({
            type: "copy_final_bisac_codes",
            payload: { book: product.id, codes_count: codesCount },
          })
        }
        onAdd={addCodes}
        onRemove={removeSubject}
        onReorder={reorder}
      />
    </div>
  );
};
